import { Link } from 'react-router-dom';
import './legal-pages.css';
import { useEffect } from 'react';

export default function TermsOfUse() {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
     <div className="legal-page">
       <div className="legal-page-banner">
         <h1 className="legal-page-title">Privacy Policy</h1>
         <div className="legal-page-actions">
           <Link to="/" className="back-pill">Back</Link>
         
         </div>
       </div>
      <p>Welcome to Dfive Coaching!</p>
      <p>These Terms of Use ("Terms") govern your access to and use of the DFIVE Coaching website and services.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using our website, you agree to comply with these Terms. If you do not agree, please do not use our services.</p>

      <h2>2. Use License</h2>
      <p>All content and materials are the intellectual property of DFIVE Coaching. You may not reproduce, distribute, or modify any content without our written permission.</p>

      <h2>3. User Conduct</h2>
      <p>You agree not to misuse our services or help anyone else do so. Examples of prohibited conduct include:</p>
      <ul>
        <li>Hacking or accessing non-public areas of our site.</li>
        <li>Interfering with the normal operation of our services.</li>
        <li>Using our services to send spam or unauthorized advertising.</li>
      </ul>

      <h2>4. Termination</h2>
      <p>We may suspend or terminate your access if you violate these Terms or misuse our services.</p>

      <h2>5. Changes</h2>
      <p>We reserve the right to modify these Terms at any time. Updated Terms will be posted on this page.</p>

      <h2>6. Contact Us</h2>
   <p>
<p>
  For questions about this Terms of Use, please contact us at&nbsp;
  <a href="mailto:coaching@dfivetechnologies.com">coaching@dfivetechnologies.com</a>.
</p>

</p>

    </div>
  );
}
